import {
  Flex,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBed,
  faCar,
  faMapLocationDot,
} from "@fortawesome/free-solid-svg-icons";
import ReservationSearchForm from "../../components/reservation-search-form/ReservationSearchForm";
import { RESERVATION_TYPES } from "../../constants";
import { useTranslation } from "react-i18next";

function ReservationTabs({
  selectedTab,
  forHomePage = true,
  isFetching,
  onSearchButtonClick,
}) {
  const navigate = useNavigate();
  const { t } = useTranslation("common");

  const tabLabels = {
    [RESERVATION_TYPES.STAY]: t("reservationTabStays"),
    [RESERVATION_TYPES.CAR]: t("reservationTabCars"),
    [RESERVATION_TYPES.TOUR]: t("reservationTabTours"),
  };

  const selectedTabStyle = {
    color: "teal.700",
    bg: "white",
    boxShadow: "sm",
    border: "2px solid",
    borderColor: "teal.500",
  };

  const tabStyle = {
    color: "gray.700",
    _hover: { color: "gray.900", bg: "gray.100" },
  };

  const tabIcons = {
    [RESERVATION_TYPES.STAY]: faBed,
    [RESERVATION_TYPES.CAR]: faCar,
    [RESERVATION_TYPES.TOUR]: faMapLocationDot,
  };

  const tabIndex = {
    [RESERVATION_TYPES.STAY]: 0,
    [RESERVATION_TYPES.CAR]: 1,
    [RESERVATION_TYPES.TOUR]: 2,
  };

  return (
    <>
      <Tabs
        isManual
        index={tabIndex[selectedTab]}
        defaultIndex={0}
        align="center"
        variant="soft-rounded"
      >
        <TabList
          marginBottom="15px"
          bg="gray.100"
          p={1}
          borderRadius="full"
          display="inline-flex"
          gap={1}
        >
          {Object.values(RESERVATION_TYPES).map((reservationType) => (
            <Tab
              key={reservationType}
              {...tabStyle}
              _selected={selectedTabStyle}
              onClick={() => navigate(`/${reservationType}s`)}
            >
              <Flex gap={2} align="center">
                <FontAwesomeIcon icon={tabIcons[reservationType]} />
                {tabLabels[reservationType]}
              </Flex>
            </Tab>
          ))}
        </TabList>
        <TabPanels>
          {Object.values(RESERVATION_TYPES).map((reservationType) => (
            <TabPanel key={reservationType} padding={0}>
              <ReservationSearchForm
                onSearchButtonClick={onSearchButtonClick}
                reservationType={reservationType}
                forHomePage={forHomePage}
                isFetching={isFetching}
                isActive={selectedTab === reservationType}
              />
            </TabPanel>
          ))}
        </TabPanels>
      </Tabs>
    </>
  );
}

export default ReservationTabs;
